module.exports = __webpack_public_path__ + "static/media/ski-jump.d6fcd37d.svg";